<div style="padding: 10px; border: solid 1px #dee2e6; margin-bottom: 10px;">
    <h5>{{title}}</h5>
    <!--Seleccion de ubicacion-->
    <mat-grid-list cols="2" rowHeight="100px" height="400px">
        <mat-grid-tile>
            <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                <mat-label>Seleccione una ubicación</mat-label>
                <mat-select formControlName="ubicacion" name="ubicaciones"
                    (selectionChange)="asingDireccion($event.value)">
                    <mat-option *ngFor="let ubicacion of ubicaciones" [value]="ubicacion.id">
                        {{ubicacion.attributes?.cat_tipo_ubicacion?.data?.attributes?.tipo }} - {{ubicacion.attributes?.nombre}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>
        <mat-grid-tile>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button
                (click)="deleteDomicilio()">Eliminar</button>
            <button class="fuse-mat-button-rounded mgbutton" mat-flat-button (click)="saveDomicilio()"
                [color]="'primary'">Guardar</button>
        </mat-grid-tile>
    </mat-grid-list>
    <hr>
    <!--Tipo de ubicacion-->
    <mat-grid-list cols="2" rowHeight="2:1">

        <mat-grid-tile class="margin-8">
            <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                <mat-label>Nombre de la ubicación</mat-label>
                <input matInput placeholder="" formControlName="nombreUbicacion" name="nombreUbicacion">
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile class="margin-8">
            <mat-form-field appearance="fill" [formGroup]="FormDomicilio" class="margin-8">
                <mat-label>Tipo ubicación</mat-label>
                <mat-select formControlName="tUbicacion" name="tUbicacion" (selectionChange)="tipoUbicacionChange($event.value)">
                    <mat-option *ngFor="let tubicacion of tubicaciones" [value]="tubicacion.id">
                        {{tubicacion.attributes?.tipo}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>


    </mat-grid-list>

    <div class="row">
        <div class="col-6">
            <div class="border" style="padding: 10px;">
                <h5>&nbsp;</h5>
                <!--ID Ubicacion-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label
                        matTooltip="Para origen el acrónimo “OR” o para destino el acrónimo “DE” seguido de 6 dígitos numéricos asignados por el contribuyente que emite el comprobante para su identificación.">IDUbicacion
                        <mat-icon class="mat-18">info</mat-icon></mat-label>
                    <input matInput placeholder="" formControlName="idUbicacion" name="idUbicacion"
                        matTooltip="Para origen el acrónimo “OR” o para destino el acrónimo “DE” seguido de 6 dígitos numéricos asignados por el contribuyente que emite el comprobante para su identificación.">
                </mat-form-field>
                <!--Fecha Hora Salida-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Fecha y Hora de {{dateText}} </mat-label>
                    <input matInput formControlName="fhSalida" name="fhSalida" type="datetime-local">
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.fhSalida.touched || submitted) && FormDomicilioControl.fhSalida.errors?.required">
                        Campo requerido
                    </span>
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.fhSalida.touched || submitted) && FormDomicilioControl.fhSalida.errors?.pattern">
                        <small>Formato incorrecto</small>
                    </span>
                </mat-form-field>
                <!--Distancia Recorrida(km)-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Distancia Recorrida(km)</mat-label>
                    <input type="number" matInput placeholder="" formControlName="distRecorrida" name="distRecorrida">
                </mat-form-field>
                <!--RFC Remitente-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>RFC {{rfcText}} </mat-label>
                    <input matInput placeholder="" formControlName="rfcRemitente" name="rfcRemitente"
                        (change)="validaRFC()">
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.rfcRemitente.touched || submitted) && FormDomicilioControl.rfcRemitente.errors?.required">
                        Campo requerido
                    </span>
                </mat-form-field>
                <!--Nombre Remitente:-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Nombre {{nameText}}:</mat-label>
                    <input matInput placeholder="" formControlName="nombreRemitente" name="nombreRemitente">
                </mat-form-field>

                <!--Num Reg IdTrib-->
                <!-- aplica las caracteristicas de NumReg al formcontronale numRegID -->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio"
                    [matTooltipPosition]="'above'"
                    matTooltip="Atributo condicional para incorporar el número de identificación o registro fiscal del país de residencia para los efectos fiscales del remitente de los bienes o mercancías que se trasladan, cuando sea residente en el extranjero.">
                    <mat-label>Num Reg IdTrib <mat-icon class="mat-18">info</mat-icon></mat-label>
                    <input matInput placeholder="" formControlName="numRegID" name="numRegID"
                        placeholder="{{ rulNumReg?.placeholder }}">
                </mat-form-field>


                <!--Residencia Fiscal-->
                <!-- cambiar mat-form-field de input por un select basado en esta lista lstPaises -->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio"
                    [matTooltipPosition]="'above'"
                    matTooltip="Atributo condicional para registrar la clave del país de residencia para efectos fiscales del remitente de los bienes o mercancías. Si se registra información en el atributo “NumRegIdTrib” este atributo debe existir, en caso contrario este atributo no debe existir.">
                    <mat-label>Residencia Fiscal</mat-label>
                    <mat-select name="mPeligroso" formControlName="residenciaFiscal">
                        <mat-option *ngFor="let pais of lstPaises" [value]="pais.idPais">
                            {{pais.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!-- <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio"
            [matTooltipPosition]="'above'"
            matTooltip="Atributo condicional para registrar la clave del país de residencia para efectos fiscales del remitente de los bienes o mercancías. Si se registra información en el atributo “NumRegIdTrib” este atributo debe existir, en caso contrario este atributo no debe existir.">
            <mat-label>Residencia Fiscal <mat-icon class="mat-18" >info</mat-icon></mat-label>
            <input matInput placeholder="" formControlName="residenciaFiscal" name="residenciaFiscal">
        </mat-form-field> -->
                <!--Navegacion Trafico-->


                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Navegacion Trafico</mat-label>

                    <mat-select formControlName="navegacionTrafico" name="navegacionTrafico">
                        <mat-option *ngFor="let item of navTrafico" [value]="item.id">
                            {{item.attributes?.tipoPuerto}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <!--Tipo Estación: -->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio"
                    [matTooltipPosition]="'above'"
                    matTooltip="Si el atributo “TranspInternac” contiene el valor “No” y si existe el nodo “Mercancias:TransporteFerroviario”, “Mercancias:TransporteMaritimo” o “Mercancias:TransporteAereo”, este atributo se debe registrar y debe contener una clave del catálogo.
            En otro caso, si el atributo “TranspInternac” contiene el valor “Sí” este atributo no debe registrarse siempre que el origen o destino de los bienes o mercancías sea fuera de
            territorio nacional, por lo que el atributo “Ubicacion:Domicilio:Pais” debe contener una clave distinta de “MEX”, en caso contrario se debe registrar una clave del catálogo.">
                    <mat-label>Tipo Estación <mat-icon class="mat-18">info</mat-icon></mat-label>
                    <!-- <input matInput placeholder="" formControlName="tipoEstacion" name="tipoEstacion"> -->

                    <mat-select formControlName="tipoEstacion" name="tipoEstacion">
                        <mat-option *ngFor="let item of tipoEstacion" [value]="item.id">
                            {{item.attributes?.tipo}}
                        </mat-option>
                    </mat-select>

                </mat-form-field>


                <!--Num Estacion-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio"
                    [matTooltipPosition]="'above'"
                    matTooltip="Si solo existe un nodo “Mercancias:AutotransporteFederal”, este atributo no 
            debe existir. En caso de que exista el nodo “Mercancias:TransporteMaritimo”, que corresponde a la
            clave “02”, “Mercancias:TransporteAereo” con valor “03” o “Mercancias:TransporteFerroviario” con clave “04”, de
            la columna “Clave transporte” del catálogo “Estaciones”; este atributo debe contener un valor de la columna “Clave identificación” que corresponda al mismo catálogo.">
                    <mat-label>Num Estacion <mat-icon class="mat-18">info</mat-icon></mat-label>
                    <input matInput placeholder="" formControlName="numEstacion" name="numEstacion">
                </mat-form-field>
            </div>
        </div>

        <div class="col-6">
            <div class="border" style="padding: 10px;">
                <h5>Domicilio</h5>
                <!--Pais-->
                <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>País</mat-label>
                    <mat-select formControlName="pais" name="pais" (selectionChange)="SelEstados($event.value)">
                        <mat-option *ngFor="let pais of paises" [value]="pais.id">
                            {{pais.attributes?.idPais}} - {{pais.attributes?.nombre}}
                        </mat-option>
                    </mat-select>
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.pais.touched || submitted) && FormDomicilioControl.pais.errors?.required">
                        Campo requerido
                    </span>
                </mat-form-field>
                <!--CodigoPostal-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Codigo Postal </mat-label>
                    <input matInput placeholder="" formControlName="cPostal" name="cPostal" (keyup)="verificaCP()"
                        onkeypress="return ((event.charCode >= 48 && event.charCode <= 57))">
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.cPostal.touched || submitted) && FormDomicilioControl.cPostal.errors?.required">
                        Campo requerido
                    </span>
                </mat-form-field>
                <!--Estado-->
                <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Estado </mat-label>
                    <mat-select formControlName="estado" name="estado" (selectionChange)="selMunicipios($event.value)">
                        <mat-option *ngFor="let estado of estados" [value]="estado.id">
                            {{estado.attributes?.idEstado}} - {{estado.attributes?.nombre}}
                        </mat-option>
                    </mat-select>
                    <span class="text-danger"
                        *ngIf="(FormDomicilioControl.estado.touched || submitted) && FormDomicilioControl.estado.errors?.required">
                        Campo requerido
                    </span>
                </mat-form-field>
                <!--Municipio-->
                <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Municipio:</mat-label>
                    <mat-select formControlName="municipio" name="municipio"
                        (selectionChange)="selLocalidades($event.value)">
                        <mat-option *ngFor="let municipio of municipios" [value]="municipio.id">
                            {{municipio.attributes?.idMunicipio}} - {{municipio.attributes?.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!--Localidad-->
                <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Localidad:</mat-label>
                    <mat-select formControlName="localidad" name="localidad">
                        <mat-option *ngFor="let localidad of localidades" [value]="localidad.id">
                            {{localidad.attributes?.idAsentamiento}} - {{localidad.attributes?.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!--Colonia-->
                <mat-form-field appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Colonia:</mat-label>
                    <!-- <mat-select formControlName="colonia" name="colonia" (selectionChange)="selColonias($event.value)"></mat-select> -->
                    <mat-select formControlName="colonia" name="colonia">
                        <mat-option *ngFor="let colonia of colonias" [value]="colonia.idAsentamiento">
                            {{colonia.nombre}}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
                <!--Calle-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Calle</mat-label>
                    <input matInput placeholder="" formControlName="calle" name="calle">
                </mat-form-field>
                <!--Numero Exterior-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Numero Exterior</mat-label>
                    <input matInput placeholder="" formControlName="numExt" name="numExt">
                </mat-form-field>
                <!--Numero Interior-->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Numero Interior</mat-label>
                    <input matInput placeholder="" formControlName="numInt" name="numInt">
                </mat-form-field>
                <!--Referencia -->
                <mat-form-field class="margin-8" appearance="fill" [formGroup]="FormDomicilio">
                    <mat-label>Referencia</mat-label>
                    <input matInput placeholder="" formControlName="referencia" name="referencia">
                </mat-form-field>
            </div>
        </div>
    </div>
</div>